import { defineMessage } from 'react-intl';
export const FILE_RETENTION_DAYS = 7;
export const FILE_RETENTION_MESSAGE = defineMessage({
    defaultMessage: 'Files attached to sessions are retained for {days, plural, one {# day} other {# days}}',
    description: 'Tooltip explaining the retention period for files attached to threads',
    id: '302963d024',
});
//# sourceMappingURL=fileRetentionMessage.js.map